import { render, staticRenderFns } from "./SystemSubjectForm.vue?vue&type=template&id=6069c079&scoped=true"
import script from "./SystemSubjectForm.ts?vue&type=script&lang=ts&external"
export * from "./SystemSubjectForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6069c079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6069c079')) {
      api.createRecord('6069c079', component.options)
    } else {
      api.reload('6069c079', component.options)
    }
    module.hot.accept("./SystemSubjectForm.vue?vue&type=template&id=6069c079&scoped=true", function () {
      api.rerender('6069c079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Masters/components/forms/SystemSubjectForm/SystemSubjectForm.vue"
export default component.exports